"use strict";

var _geolocated = require("./components/geolocated");

var _geolocated2 = _interopRequireDefault(_geolocated);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = { geolocated: _geolocated2.default, geoPropTypes: _geolocated.geoPropTypes };


//////////////////
// WEBPACK FOOTER
// ./~/react-geolocated/dist-modules/index.js
// module id = 1100
// module chunks = 0